define('setup/save-test-variations',['require','exports','module','jquery','lib/check-first-visit','lib/multivariate-testing/multivariate-testing'],function (require, exports, module) {
    var $ = require('jquery');
    var checkFirstVisit = require('lib/check-first-visit');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    module.exports = function () {
        var savingTestVariations = $.Deferred();

        checkFirstVisit.check().then(function (isFirstVisit) {
            if (isFirstVisit) {
                multivariateTesting.saveVariation('inProductPurchaseTest');
                multivariateTesting.saveVariation('g2mmSchedulingTest').always(function () {
                    savingTestVariations.resolve();
                });
            } else {
                savingTestVariations.resolve();
            }
        });

        return savingTestVariations.promise();
    };
});

